import "@/App.css";

import {
  HashRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// Main application pages
import DashboardPage from "@/pages/DashboardPage";
import ExpensesPage from "@/pages/ExpensesPage";

// HRMS
import HrmsDashboardPage from "@/pages/hrms/HrmsDashboardPage";
import EmployeesPage from "@/pages/hrms/EmployeesPage";
import AttendancePage from "@/pages/hrms/AttendancePage";
import LeavesPage from "@/pages/hrms/LeavesPage";
import PayrollPage from "@/pages/hrms/PayrollPage";
import ReportsPage from "@/pages/hrms/ReportsPage";
import SettingsPage from "@/pages/hrms/SettingsPage";

// Other modules
import BillingPage from "@/pages/billing/BillingPage";
import DiscomPage from "@/pages/discom/DiscomPage";
import InventoryPage from "@/pages/inventory/InventoryPage";
import DtInspectionPage from "@/pages/dt/DtInspectionPage";
import InstallationOperationsPage from "@/pages/operations/InstallationOperationsPage";

// Authentication
import AdminLogin from "@/pages/admin/AdminLogin";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";

// Admin-only functions
import UsersPage from "@/pages/admin/UsersPage";
import ResourcesPage from "@/pages/admin/ResourcesPage";
import ActivityLogPage from "@/pages/admin/ActivityLogPage";

// Common
import AdminRoute from "@/components/admin/AdminRoute";
import OfflineBanner from "@/components/OfflineBanner";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <OfflineBanner />

        <Routes>
          {/* Authentication */}
          <Route
            path="/admin/login"
            element={<AdminLogin />}
          />

          <Route
            path="/admin/forgot-password"
            element={<ForgotPassword />}
          />

          <Route
            path="/admin/reset-password"
            element={<ResetPassword />}
          />

          <Route
            path="/privacy"
            element={<PrivacyPolicy />}
          />

          {/* Main Dashboard */}
          <Route
            path="/"
            element={
              <AdminRoute requiredPermission="view">
                <DashboardPage />
              </AdminRoute>
            }
          />

          {/* Daily Expenses */}
          <Route
            path="/expenses"
            element={
              <AdminRoute requiredPermission="view">
                <ExpensesPage />
              </AdminRoute>
            }
          />

          {/* HRMS */}
          <Route
            path="/hrms"
            element={
              <AdminRoute requiredPermission="view">
                <HrmsDashboardPage />
              </AdminRoute>
            }
          />

          <Route
            path="/hrms/employees"
            element={
              <AdminRoute requiredPermission="view">
                <EmployeesPage />
              </AdminRoute>
            }
          />

          <Route
            path="/hrms/attendance"
            element={
              <AdminRoute requiredPermission="view">
                <AttendancePage />
              </AdminRoute>
            }
          />

          <Route
            path="/hrms/leaves"
            element={
              <AdminRoute requiredPermission="view">
                <LeavesPage />
              </AdminRoute>
            }
          />

          <Route
            path="/hrms/payroll"
            element={
              <AdminRoute requiredPermission="view">
                <PayrollPage />
              </AdminRoute>
            }
          />

          <Route
            path="/hrms/reports"
            element={
              <AdminRoute requiredPermission="reports">
                <ReportsPage />
              </AdminRoute>
            }
          />

          <Route
            path="/hrms/settings"
            element={
              <AdminRoute requireAdmin>
                <SettingsPage />
              </AdminRoute>
            }
          />

          {/* Vendor Billing */}
          <Route
            path="/billing"
            element={
              <AdminRoute requiredPermission="view">
                <BillingPage />
              </AdminRoute>
            }
          />

          {/* DISCOM */}
          <Route
            path="/discom"
            element={
              <AdminRoute requiredPermission="view">
                <DiscomPage />
              </AdminRoute>
            }
          />

          {/* Material Inventory */}
          <Route
            path="/inventory"
            element={
              <AdminRoute requiredPermission="view">
                <InventoryPage />
              </AdminRoute>
            }
          />

          {/* DT Inspection */}
          <Route
            path="/dt-inspection"
            element={
              <AdminRoute requiredPermission="view">
                <DtInspectionPage />
              </AdminRoute>
            }
          />

          {/* Installation & Operations */}
          <Route
            path="/installation-operations"
            element={
              <AdminRoute requiredPermission="view">
                <InstallationOperationsPage />
              </AdminRoute>
            }
          />

          {/* Legacy Admin URL */}
          <Route
            path="/admin"
            element={
              <Navigate to="/" replace />
            }
          />

          {/* Admin Only */}
          <Route
            path="/admin/users"
            element={
              <AdminRoute requireAdmin>
                <UsersPage />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/resources"
            element={
              <AdminRoute requireAdmin>
                <ResourcesPage />
              </AdminRoute>
            }
          />

          <Route
            path="/admin/activity"
            element={
              <AdminRoute requireAdmin>
                <ActivityLogPage />
              </AdminRoute>
            }
          />

          {/* Unknown routes */}
          <Route
            path="*"
            element={
              <Navigate to="/" replace />
            }
          />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;